<template>
  <v-app :style="`background-color: ${settings.background_color}`">
    <MainCom
      :data="items"
      v-if="items.length"
      :timeZone="timeZone"
      :stop_name="stop_name"
      :settings="settings"
    >
    </MainCom>
    <v-container
      v-else
      style="background-color: black"
      class="pa-0 ma-0"
      fluid
      fill-height
    >
      <v-row class="pa-0 ma-0" align="center" justify="center">
        <v-col
          cols="12"
          style="color: azure"
          align="center"
          justify="center"
          class="pa-0 ma-0 text-h2"
        >
          {{ loading_text }}
        </v-col></v-row
      ></v-container
    >
  </v-app>
</template>

<script>
let removeOldDataTimer = null;
import MainCom from "./components/MainCom.vue";
import { fetchTransportData, removeOldData } from "./fns";
export default {
  name: "App",
  provide() {
    return {
      h1Class: this.h1Class,
      h2Class: this.h2Class,
      h3Class:this.h3Class,
      header_background_color: this.settings.header_background_color,
      header_font_color: this.settings.header_font_color,
      background_color: this.settings.background_color,
      font_color: this.settings.font_color,
      size: this.size,
      maxSize: this.maxSize,
    };
  },

  data() {
    return {
      settings: {
        background_color: "#F5F5F5",
        font_color: "#000000",
        header_background_color: "#0000ff",
        header_font_color: "#FFFFFF",
        name: "Next service",
      },
      background_color: "#F5F5F5",
      media: {},
      stop_name: "",
      timerUpdater: null,
      data: [],
      timeZone: "Europe/Dublin",
      loading_text: "LOADING...",
    };
  },
  components: {
    MainCom,
  },
  computed: {
    items() {
      return (this.data || []).slice(0, this.maxSize);
    },
    maxSize() {
      const { name } = this.$vuetify.breakpoint;
      switch (this.size) {
        case "horz":
          return this.getHorzMax(name);
        case "vert":
          return this.getVertMax(name);
      }
      return 7;
    },
    size() {
      const { width, height } = this.$vuetify.breakpoint;
      if (width <= height) return "vert";
      return "horz";
    },
    h1Class() {
      const { name } = this.$vuetify.breakpoint;
      switch (this.size) {
        case "horz":
          return this.horzClass1(name);

        case "vert":
          return this.vertClass1(name);
        default:
          return "";
      }
    },
    h3Class() {
      const { name } = this.$vuetify.breakpoint;
      switch (name) {
        case "xs":
          return "text-h7"
        default:
          return "text-h5";
      }
    },
    h2Class() {
      const { name } = this.$vuetify.breakpoint;
      switch (this.size) {
        case "horz":
          return this.horzClass2(name);
        case "vert":
          return this.vertClass2(name);
        default:
          return "";
      }
    },
  },
  created() {
    window.loadData = this.loadData;
    //window.name = ``;
    //window.name = `{"id": "hwscmiSsmmLBFGnfUH4m","email":"support@screenfusion.ai","brand":"screenfusion"}`;
    if (window.name) {
      const data = JSON.parse(window.name);

      if (data) this.loadData(data);
    }
    clearInterval(removeOldDataTimer);
    removeOldDataTimer = setInterval(this.removeOldData, 5000);
  },
  methods: {
    getVertMax(size) {
      const { height } = this.$vuetify.breakpoint;
      switch (size) {
        case "xs":
          if (height > 1000) {
            return 7;
          }
          if(height<550)
          return 4
          return 6;
          
        case "sm":
         if (height > 1000) {
            return 7;
          }
          return 6;
        case "md":
          if (height > 1900) {
            return 16;
          }
          if (height > 1700) {
            return 15;
          }
          if (height > 1500) {
            return 13;
          }
      }
    },
    getHorzMax(size) {
      const { height } = this.$vuetify.breakpoint;
      switch (size) {
        case "md":
          if (height < 700) {
            return 4;
          }
          break;
        case "lg":
          if (height > 1000) {
            return 8;
          }
          if (height < 1000 && height > 900) {
            return 7;
          }
          if (height < 900 && height > 800) {
            return 6;
          }
          break;
        case "xl":
          if (height > 1000) {
            return 7;
          }
          if (height < 1000 && height > 900) {
            return 6;
          }
          break;
      }
      return 8;
    },
    horzClass1(size) {
      switch (size) {
        case "xs":
        case "sm":
          return "text-h6";
        case "md":
        case "lg":
          return "text-h4";
      }
      return "display-3 text-truncate";
    },
    horzClass2(size) {
      switch (size) {
        case "xs":
        case "sm":
          return "text-h6 ";
        case "md":
        case "lg":
          return "text-h4";
      }
      return "display-2";
    },
    vertClass1(size) {
      switch (size) {
        case "xs":
        return "text-h7";
        case "sm":
          return "text-h5";
        case "md":
        case "lg":
          return "text-h4";
      }
      return "display-3 text-truncate";
    },
    vertClass2(size) {
      switch (size) {
        case "xs":
        return "text-h7";
        case "sm":
          return "text-h5";
        case "md":
        case "lg":
          return "text-h5";
      }
      return "display-3";
    },
    setUpSettings() {
      this.settings = {
        name: this.settings.name || "Next service",
        background_color: this.settings.background_color || "#F5F5F5",
        font_color: this.settings.font_color || "#000000",
        header_background_color:
          this.settings.header_background_color || "#673AB7FF",
        header_font_color: this.settings.header_font_color || "#FFFFFF",
      };
    },
    removeOldData() {
      this.data = removeOldData(this.data, this.timeZone);
    },
    async updateNow() {
      this.loading_text = "LOADING...";
      const res = await fetchTransportData(
        this.media.brand,
        this.media.email,
        this.media.id,
        this.timeZone
      );
      if (res.status) {
        this.settings = res.data?.settings || {};
        this.setUpSettings();
        this.data = Array.isArray(res.data?.services)
          ? res.data.services
          : [];
        if (this.data?.length) this.stop_name = this.data[0].stop_name;
        else this.loading_text = "NO AVAILABLE SERVICES";
      }
    },
    loadData(media) {
      this.media = typeof media === "object" ? media : JSON.parse(media);
      this.start();
    },

    start() {
      if (this.timerUpdater) window.clearInterval(this.timerUpdater);
      this.updateNow();
      this.timerUpdater = setInterval(() => {
        this.updateNow();
      }, 1000 * 5 * 60); //every 5 mins
    },
  },
  mounted() {
    if (window.localMediaData) this.loadData(window.localMediaData);
    window.addEventListener(
      "message",
      (event) => {
        eval(event.data);
      },
      false
    );
  },
};
</script>

<style></style>
